import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-left-menu',
  templateUrl: './left-menu.component.html'  
})
export class LeftMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
